import { formatObservedWeatherMonthPill } from '../../lib/observedWeather';

interface ClimateMonthPickerProps {
  options: string[];
  selected: string[];
  onToggle: (period: string, enabled: boolean) => void;
  emptyMessage?: string;
}

/** Multi-select month list — checkboxes, plain language. */
export function ClimateMonthPicker({
  options,
  selected,
  onToggle,
  emptyMessage = 'No months available yet.',
}: ClimateMonthPickerProps) {
  const sorted = [...options].sort().reverse();
  const selectedSet = new Set(selected);

  if (sorted.length === 0) {
    return <p className="text-xs text-gray-500 dark:text-gray-400">{emptyMessage}</p>;
  }

  return (
    <div
      className="max-h-36 overflow-y-auto rounded-lg border border-gray-200 bg-gray-50/80 dark:border-gray-700 dark:bg-gray-800/40"
      role="group"
      aria-label="Choose months to compare"
    >
      {sorted.map((period) => {
        const active = selectedSet.has(period);
        return (
          <label
            key={period}
            className={`flex cursor-pointer items-center gap-2.5 border-b border-gray-100 px-3 py-2 last:border-b-0 dark:border-gray-800 ${
              active
                ? 'bg-primary-50 dark:bg-primary-950/30'
                : 'hover:bg-gray-100/80 dark:hover:bg-gray-800/60'
            }`}
          >
            <input
              type="checkbox"
              checked={active}
              onChange={(e) => onToggle(period, e.target.checked)}
              className="rounded border-gray-300 text-primary-600 focus:ring-primary-500 dark:border-gray-600"
            />
            <span
              className={`text-sm ${
                active
                  ? 'font-medium text-gray-900 dark:text-white'
                  : 'text-gray-700 dark:text-gray-300'
              }`}
            >
              {formatObservedWeatherMonthPill(period)}
            </span>
          </label>
        );
      })}
    </div>
  );
}
